import React from 'react';

import TextField from "@material-ui/core/TextField";

import { ethers } from 'ethers';

function HexStringTextField (props) {
  const {
    value,
    mandatory = true,
    readOnly = false,
    disabled = false,
    validator,
    rows = 4,
    ...other
  } = props;

  let error = false;
  let helperText = ' ';

  const trimmedValue = value.trim ();
  const lowerCaseValue = trimmedValue.toLowerCase ();

  if (readOnly || disabled || (!mandatory && lowerCaseValue === '')) {
    // Do nothing
  } else if (!lowerCaseValue.match (/^0x([0-9a-f]{2})*$/)) {
    error = true;
    helperText = lowerCaseValue ? 'Invalid hex string' : 'Enter valid hex string, please';
  } else if (validator) {
    const array = ethers.utils.arrayify (lowerCaseValue);

    const validatorMessage = validator (array);
    if (validatorMessage) {
      error = true;
      helperText = validatorMessage;
    }
  }

  return (
    <TextField disabled={disabled}
               multiline
               rows={rows}
               placeholder={readOnly || disabled ? undefined : '0x0000...'}
               helperText={helperText}
               error={error}
               value={value}
               InputLabelProps={{ shrink: true }}
               InputProps={{ readOnly: readOnly }}
               variant="outlined"
               {...other} />
  );
}

export default HexStringTextField;
